module.exports = "https://coursera_assets.s3.amazonaws.com/images/793117d911d01cab31b104b041b4fbcd.png";